import React from "react";
import PropTypes from "prop-types";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { Grid, Paper, Typography } from "@material-ui/core";
import { Dashboard as DashboardLayout } from "layouts";
import styles from "theme/skin";
import AddSalesRep from "./AddSalesRep";
import SalesGrid from "./SalesGrid";
import "./mySalesRep.scss";

function MySalesRep(props) {
  const { classes } = props;
  return (
    <DashboardLayout title="My Dealers">
      <div className={classes.root + " sectionContainer"}>
        <Typography gutterBottom variant="h4" className="title">
          <span>My Sales Rep</span>
        </Typography>
      </div>
        <Paper className={classes.paper} style={{ margin: "2em 3em" }}>
          <Grid container>
            <Grid item xs align="center">
              <AddSalesRep />
            </Grid>
          </Grid>
        </Paper>

        <Paper className={classes.paper} style={{ margin: "2em 3em" }}>
          <Grid container>
            <Grid item xs align="center">
              <SalesGrid />
            </Grid>
          </Grid>
        </Paper>
      
    </DashboardLayout>
  );
}

MySalesRep.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MySalesRep);
